<template>
    <v-dialog v-model="$store.state.customers.manageDeleteCustomerDialog" width="500">
        <v-card>
            <v-card-title class="red white--text" primary-title>Are you sure you want to delete this customer?</v-card-title>
            <v-card-text>
                <h5 class="title">This action cannot be undone</h5>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="confirmDelete"><v-icon left>mdi-delete</v-icon>Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {EventBus} from "../../../EventBus";
    import {CustomersHttp} from "../../../http/customers";

    export default {
        name: "DeleteCustomerDialog",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
          customer: {
            get() {
              return this.$store.state.customers.activeCustomer;
            }
          }
        },
        methods: {
            closeDialog() {
                this.$store.dispatch('customers/setActiveCustomer', {});
                this.$store.dispatch('customers/setManageDeleteCustomerDialog', false);
                this.$store.dispatch('customers/setCustomers');
            },
            async confirmDelete() {
                this.isLoading = true;
                try {
                    await CustomersHttp.deleteCustomer(this.customer._id);
                    EventBus.$emit('message', {message: 'Customer deleted successfully', type: 'success'});
                    await this.$store.dispatch('customers/setActiveCustomer', {});
                    await this.$store.dispatch('customers/setManageDeleteCustomerDialog', false);
                    await this.$store.dispatch('customers/setCustomers');
                } catch (e) {
                    EventBus.$emit('message', {message: e, type: 'error'});
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
